import { Icon } from 'components/atoms';
import fontService, { FontWeight } from 'services/FontService';
import styled, { css } from 'styled-components';
import { RouletteColorResult } from 'types/tables';

export const resultStyles = {
  [RouletteColorResult.RED]: css`
    background: linear-gradient(180deg, #ff002a 0%, #c8102e 100%);
  `,
  [RouletteColorResult.BLACK]: css`
    background: linear-gradient(180deg, #303030 0%, #141414 100%);
  `,
  [RouletteColorResult.GREEN]: css`
    background: linear-gradient(180deg, #4cc620 0%, #43ac1d 100%);
  `,
  [RouletteColorResult.UNDEFINED]: css`
    background: #32313b;
  `,
};

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(52, 52, 52, 0) 45.86%, #343434 100%);
`;

export const ResultValueBG = styled(Icon)`
  position: absolute;
  top: -50px;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0.6;
`;

export const ResultsWrap = styled.div`
  position: absolute;
  top: 140px;
`;

export const Result = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const ResultValue = styled.div<{ value: RouletteColorResult }>`
  width: 160px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ value }) => css`
    box-shadow: ${value !== RouletteColorResult.UNDEFINED && '0px -4px 8px 0px #fff7eb33'};
    ${resultStyles[value]};
    border: ${value !== RouletteColorResult.UNDEFINED ? '3px solid #dfe6f4' : '2px solid #dfe6f4'};
  `};
`;

export const ResultLabel = styled.p`
  ${fontService.getFont({ size: 40, lineHeight: 100, weight: FontWeight.bold })};
  ${({ theme: { text } }) => css`
    color: ${text.primaryDefault};
  `};
`;

export const ResultItem = styled.div`
  ${fontService.getFont({ size: 80, lineHeight: 84, weight: FontWeight.bold })};
  ${({ theme: { text } }) => css`
    color: ${text.primaryDefault};
  `};
`;
